import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { Divider, Grid, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DropDown from "../../../Components/DropDown/DropDown";
import MuiInputField from "../../../Components/InputField/InputField";
import AddButton from "../../../Components/AddButton/AddButton";
import { checkNumberLimit, isEmpty } from "../../../Utils/helper";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

function AlertPopUp(props) {
  return (
    <Box
      sx={{
        ...style,
        width: 400,
        border: "1px solid lightgray",
        height: 200,
        borderRadius: "15px",
        outline: "none",
        padding: 0,
      }}
    >
      <Grid container justifyContent="flex-end" alignItems={"center"}>
        <Box
          onClick={() =>
            props.setOpenModal({
              isOpen: false,
            })
          }
          sx={{
            width: 20,
            height: 20,
            backgroundColor: "#adbdd6",
            borderRadius: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: "10px",
            marginTop: "10px",
            cursor: "pointer",
          }}
        >
          <CloseIcon
            sx={{
              width: 15,
              color: "white",
            }}
          />
        </Box>
      </Grid>
      <Grid>
        <Typography sx={{ textAlign: "center", fontWeight: "bold" }}>
          {props?.headText}
        </Typography>
      </Grid>
      <Grid
        container
        item
        lg={11.5}
        height={"90px"}
        justifyContent="center"
        alignItems={"center"}
        sx={{ gap: "5px" }}
      >
        {props?.data.buttons.map((item) => {
          return (
            <Button>
              <Box
                onClick={() => {
                  if (item.buttonName === "No") {
                    props?.setOpenModal({ isOpen: false });
                  } else if (item.buttonName == "Yes") {
                    props.handleYes();
                  }
                }}
                sx={{
                  padding: "10px 30px",
                  borderRadius: "6px",
                  border: item.buttonName === "No" ? "1px solid black" : "none",
                  backgroundColor:
                    item.buttonName === "No"
                      ? "#fff"
                      : props.warning
                      ? "red"
                      : "#17dfba",
                  textTransform: "capitalize",
                }}
              >
                <Typography
                  sx={{
                    color: item.buttonName === "No" ? "#000" : "white",
                  }}
                >
                  {item.buttonName}
                </Typography>
              </Box>
            </Button>
          );
        })}
      </Grid>
    </Box>
  );
}

function AddNewInsurance(props) {
  return (
    <Box
      sx={{
        ...props.style,
        width: 700,
        border: "1px solid lightgray",
        height: 350,
        borderRadius: "15px",
        outline: "none",
        padding: "15px",
      }}
    >
      <Grid container justifyContent="space-between" alignItems={"center"}>
        <Grid>
          <Typography
            sx={{
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            Add new Insurance
          </Typography>
        </Grid>
        <Box
          onClick={() =>
            props.setOpenModal({
              isOpen: false,
            })
          }
          sx={{
            width: 25,
            height: 25,
            backgroundColor: "#adbdd6",
            borderRadius: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: "10px",
            marginTop: "10px",
            cursor: "pointer",
          }}
        >
          <CloseIcon
            sx={{
              width: 15,
              color: "white",
            }}
          />
        </Box>
      </Grid>
      <Grid paddingY={1}>
        <Divider />
      </Grid>
      <Grid
        item
        container
        justifyContent="space-between"
        lg={12}
        paddingX={3}
        paddingY={3}
      >
        <Grid item lg={3}>
          <Typography>Insurance Name</Typography>
          <MuiInputField
            type="text"
            value={props.insurance.name}
            onChange={(event) => {
              props.setInsurance((s) => ({ ...s, name: event.target.value }));
            }}
            placeHolder={"Add Insurnce name"}
          />
        </Grid>
        <Grid item lg={4}>
          <Typography>Contact Person Name</Typography>
          <MuiInputField
            type="text"
            value={props.insurance.contactName}
            onChange={(event) => {
              props.setInsurance((s) => ({
                ...s,
                contactName: event.target.value,
              }));
            }}
            placeHolder={"Add name"}
          />
        </Grid>
        <Grid item lg={4}>
          <Typography>Contact Person Number</Typography>
          <MuiInputField
            type="number"
            value={props.insurance.contactNumber}
            onChange={(event) => {
              props.setInsurance((s) => ({
                ...s,
                contactNumber: event.target.value,
              }));
            }}
            placeHolder={"Add Number"}
            maxLength={16}
          />
        </Grid>
      </Grid>
      <Grid
        container
        item
        lg={12}
        height={"80px"}
        justifyContent="flex-end"
        alignItems={"center"}
        sx={{
          gap: "5px",
        }}
      >
        {props.buttons.map((item) => {
          return (
            <Button>
              <Box
                onClick={() => {
                  if (item.buttonName === "Cancel") {
                    props.setOpenModal({
                      isOpen: false,
                    });
                  } else if (item.buttonName == "Add") {
                    props.onSave();
                  }
                }}
                sx={{
                  padding: "10px 30px",
                  borderRadius: "6px",
                  border: "none",
                  backgroundColor:
                    item.buttonName == "Add" ? "#17dfba" : "grey",
                  textTransform: "capitalize",
                }}
              >
                <Typography
                  sx={{
                    color: "white",
                  }}
                >
                  {item.buttonName}
                </Typography>
              </Box>
            </Button>
          );
        })}
      </Grid>
    </Box>
  );
}

export default function InsurancePopUp({ setOpenModal, openModal, data }) {
  const handleOpen = () => {
    setOpenModal({ isOpen: true });
  };
  const handleClose = () => {
    setOpenModal({ isOpen: false });
  };

  //   const [stateList, setStateList] = React.useState([]);

  const [insurance, setInsurance] = React.useState({});

  React.useEffect(() => {
    setInsurance({
      name: data?.data?.value?.cellItem1,
      contactName: data?.data?.value?.cellItem2,
      contactNumber: data?.data?.value?.cellItem3,
    });
  }, [data]);

  return (
    <div style={{ display: "none" }}>
      <Button onClick={handleOpen}>Open modal</Button>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        {data?.data?.type == "INSURANCE" ? (
          <AddNewInsurance
            setOpenModal={setOpenModal}
            style={style}
            buttons={data?.data?.buttons}
            insurance={insurance}
            setInsurance={setInsurance}
            onSave={() => {
              if (insurance.contactNumber && insurance.name) {
                data?.data?.save(
                  {
                    contactName: insurance.contactName,
                    contactNumber: insurance.contactNumber,
                    insuranceName: insurance.name,
                  },
                  data?.data?.value?.id
                );
                setOpenModal({
                  isOpen: false,
                });
              } else {
                alert("Insurance name and contact number are mandatory!");
              }
            }}
          ></AddNewInsurance>
        ) : (
          <AlertPopUp
            headText={
              data?.data?.type == "DELETE"
                ? "Are you sure want to delete?"
                : data?.data?.type == "FLAG"
                ? "Are you sure want to Flag?"
                : data?.data?.checked
                ? "Are you sure want to approve?"
                : "Are you sure want to un approve?"
            }
            setOpenModal={setOpenModal}
            handleYes={() => {
              if (data?.data?.type == "DELETE") {
                data?.data?.deleteData(data?.data?.deletedId);
                setOpenModal({ isOpen: false });
              } else {
                console.log(data?.data?.approve, "approve");
                data?.data?.handleApprove(
                  data?.data?.checked,
                  data?.data?.index
                );
                setOpenModal({ isOpen: false });
              }
            }}
            warning={data?.data?.type == "DELETE"}
            data={data.data}
          />
        )}
      </Modal>
    </div>
  );
}
